"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SA = void 0;
exports.SA = {
    numericCode: '682',
    alpha2Code: 'SA',
    alpha3Code: 'SAU',
    englishName: {
        short: 'Saudi Arabia',
        full: 'the Kingdom of Saudi Arabia',
    },
    names: {
        full: {
            en: 'the Kingdom of Saudi Arabia',
            fr: "le Royaume d'Arabie saoudite",
            ar: 'As Su‘ūdīyah',
        },
        short: {
            en: 'Saudi Arabia',
            fr: "Arabie saoudite (l')",
            ar: 'As Su‘ūdīyah',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'ar',
            languageAlpha3Code: 'ara',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'SA-01': {
            numericCode: '682',
            code: 'SA-01',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Ar Riyāḑ',
            },
        },
        'SA-02': {
            numericCode: '682',
            code: 'SA-02',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Makkah al Mukarramah',
            },
        },
        'SA-03': {
            numericCode: '682',
            code: 'SA-03',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Madīnah al Munawwarah',
            },
        },
        'SA-04': {
            numericCode: '682',
            code: 'SA-04',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Ash Sharqīyah',
            },
        },
        'SA-05': {
            numericCode: '682',
            code: 'SA-05',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Qaşīm',
            },
        },
        'SA-06': {
            numericCode: '682',
            code: 'SA-06',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: "Ḩā'il",
            },
        },
        'SA-07': {
            numericCode: '682',
            code: 'SA-07',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Tabūk',
            },
        },
        'SA-08': {
            numericCode: '682',
            code: 'SA-08',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Ḩudūd ash Shamālīyah',
            },
        },
        'SA-09': {
            numericCode: '682',
            code: 'SA-09',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Jāzān',
            },
        },
        'SA-10': {
            numericCode: '682',
            code: 'SA-10',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Najrān',
            },
        },
        'SA-11': {
            numericCode: '682',
            code: 'SA-11',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Bāḩah',
            },
        },
        'SA-12': {
            numericCode: '682',
            code: 'SA-12',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Jawf',
            },
        },
        'SA-14': {
            numericCode: '682',
            code: 'SA-14',
            category: {
                id: '214',
                names: {
                    ar: {
                        singular: 'minţaqah',
                        plural: '',
                    },
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: 'régions',
                    },
                },
            },
            parent: '',
            names: {
                ar: "'Asīr",
            },
        },
    },
    cities: [
        {
            name: 'Yanbu',
            subdivision: 'Al Madīnah al Munawwarah',
        },
        {
            name: 'Umm Lajj',
            subdivision: 'Minţaqat Tabūk',
        },
        {
            name: 'Ţurayf',
            subdivision: 'Northern Borders',
        },
        {
            name: 'Turabah',
            subdivision: 'Makkah',
        },
        {
            name: 'Tārūt',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Tabuk',
            subdivision: 'Minţaqat Tabūk',
        },
        {
            name: 'Ţubarjal',
            subdivision: 'Al Jawf',
        },
        {
            name: 'Sulţānah',
            subdivision: 'Al Madīnah al Munawwarah',
        },
        {
            name: 'Sayhāt',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Şāmitah',
            subdivision: 'Jizan',
        },
        {
            name: 'Sakakah',
            subdivision: 'Al Jawf',
        },
        {
            name: 'Şafwá',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Şabyā',
            subdivision: 'Jizan',
        },
        {
            name: 'Raḩīmah',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Rābigh',
            subdivision: 'Makkah',
        },
        {
            name: 'Qal‘at Bīshah',
            subdivision: 'Minţaqat ‘Asīr',
        },
        {
            name: 'Najrān',
            subdivision: 'Najrān',
        },
        {
            name: 'Mecca',
            subdivision: 'Makkah',
        },
        {
            name: 'Khamis Mushait',
            subdivision: 'Minţaqat ‘Asīr',
        },
        {
            name: 'Jizan',
            subdivision: 'Jizan',
        },
        {
            name: 'Jeddah',
            subdivision: 'Makkah',
        },
        {
            name: "Ha'il",
            subdivision: 'Ḩāʼil',
        },
        {
            name: 'Duba',
            subdivision: 'Minţaqat Tabūk',
        },
        {
            name: 'Buraydah',
            subdivision: 'Al-Qassim',
        },
        {
            name: 'Abqaiq',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Badr Ḩunayn',
            subdivision: 'Al Madīnah al Munawwarah',
        },
        {
            name: 'Az Zulfi',
            subdivision: 'Ar Riyāḑ',
        },
        {
            name: 'Dhahran',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Aţ Ţaraf',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Ta’if',
            subdivision: 'Makkah',
        },
        {
            name: 'As Sulayyil',
            subdivision: 'Ar Riyāḑ',
        },
        {
            name: 'Riyadh',
            subdivision: 'Ar Riyāḑ',
        },
        {
            name: 'Ar Rass',
            subdivision: 'Al-Qassim',
        },
        {
            name: '‘Ar‘ar',
            subdivision: 'Northern Borders',
        },
        {
            name: 'An Nimāş',
            subdivision: 'Minţaqat ‘Asīr',
        },
        {
            name: 'Qurayyat',
            subdivision: 'Al Jawf',
        },
        {
            name: 'Al Wajh',
            subdivision: 'Minţaqat Tabūk',
        },
        {
            name: 'Al ‘Ulá',
            subdivision: 'Al Madīnah al Munawwarah',
        },
        {
            name: 'Al Qayşūmah',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Qaţīf',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Munayzilah',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Mubarraz',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Mithnab',
            subdivision: 'Al-Qassim',
        },
        {
            name: 'Medina',
            subdivision: 'Al Madīnah al Munawwarah',
        },
        {
            name: 'Khobar',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Khafjī',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Jumūm',
            subdivision: 'Makkah',
        },
        {
            name: 'Al Jubayl',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Hufūf',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Bukayrīyah',
            subdivision: 'Al-Qassim',
        },
        {
            name: 'Al Baţţālīyah',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Bāḩah',
            subdivision: 'Minţaqat al Bāḩah',
        },
        {
            name: '‘Afīf',
            subdivision: 'Ar Riyāḑ',
        },
        {
            name: 'Ad Dilam',
            subdivision: 'Ar Riyāḑ',
        },
        {
            name: 'Ad Dawādimī',
            subdivision: 'Ar Riyāḑ',
        },
        {
            name: 'Dammam',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Abū ‘Arīsh',
            subdivision: 'Jizan',
        },
        {
            name: 'Abha',
            subdivision: 'Minţaqat ‘Asīr',
        },
        {
            name: 'Ash Shafā',
            subdivision: 'Makkah',
        },
        {
            name: 'Unaizah',
            subdivision: 'Al-Qassim',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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